import Clinrec from './Clinrec'
export default Clinrec
